/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Domain mapping data
 * @export
 * @interface AddDomainToCustomerRequest
 */
export interface AddDomainToCustomerRequest {
    /**
     * Domain name
     * @type {string}
     * @memberof AddDomainToCustomerRequest
     */
    domain: string;
    /**
     * Keycloak alias for the domain
     * @type {string}
     * @memberof AddDomainToCustomerRequest
     */
    keycloakAlias: string;
    /**
     * SSO provider type
     * @type {string}
     * @memberof AddDomainToCustomerRequest
     */
    providerType: string;
    /**
     * SSO provider configuration
     * @type {{ [key: string]: any; }}
     * @memberof AddDomainToCustomerRequest
     */
    providerConfig?: { [key: string]: any; };
    /**
     * Whether to use enterprise application (if available) instead of customer's own app registration. If true and enterprise app is available, clientId/clientSecret in providerConfig are ignored. If false or null, customer's own app registration credentials are required.
     * @type {boolean}
     * @memberof AddDomainToCustomerRequest
     */
    useEnterpriseApp?: boolean;
}

/**
 * Check if a given object implements the AddDomainToCustomerRequest interface.
 */
export function instanceOfAddDomainToCustomerRequest(value: object): value is AddDomainToCustomerRequest {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('keycloakAlias' in value) || value['keycloakAlias'] === undefined) return false;
    if (!('providerType' in value) || value['providerType'] === undefined) return false;
    return true;
}

export function AddDomainToCustomerRequestFromJSON(json: any): AddDomainToCustomerRequest {
    return AddDomainToCustomerRequestFromJSONTyped(json, false);
}

export function AddDomainToCustomerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDomainToCustomerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'keycloakAlias': json['keycloakAlias'],
        'providerType': json['providerType'],
        'providerConfig': json['providerConfig'] == null ? undefined : json['providerConfig'],
        'useEnterpriseApp': json['useEnterpriseApp'] == null ? undefined : json['useEnterpriseApp'],
    };
}

export function AddDomainToCustomerRequestToJSON(json: any): AddDomainToCustomerRequest {
    return AddDomainToCustomerRequestToJSONTyped(json, false);
}

export function AddDomainToCustomerRequestToJSONTyped(value?: AddDomainToCustomerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'keycloakAlias': value['keycloakAlias'],
        'providerType': value['providerType'],
        'providerConfig': value['providerConfig'],
        'useEnterpriseApp': value['useEnterpriseApp'],
    };
}

